module.exports = __webpack_public_path__ + "img/phone_assistance.4b641b73.svg";